// ─── Tabs & Modalities ────────────────────────────────────────────────────────
export const TABS = ["Registros", "Torneios", "Gráfico"];
export const MODALIDADES = ["Vanilla", "KO", "PKO", "Mystery", "Hyper/Turbo", "Freezeout", "SAT", "SNG"];
export const KO_MODS = ["KO", "PKO"];

// ─── Pagination ───────────────────────────────────────────────────────────────
export const PAGE_SIZE = 20;

// ─── Storage Keys ──────────────────────────────────────────────────────────────
export const STORAGE_KEYS = {
  tournaments: "pt_tournaments",
  registros: "pt_registros",
  simplifiedBankroll: "orion33_simplified_bankroll",
};

export const INIT_SIMPLIFIED_BANKROLL = {
  base: "",
  baseCurrency: "USD",
  accounts: [],
  platforms: {},
  withdrawals: {},
  deposits: {},
  history: [],
};

// ─── Form Defaults ────────────────────────────────────────────────────────────
export const INIT_TOURNAMENT_FORM = {
  nome: "",
  buyin: "",
  plataforma: "",
  modalidade: "Vanilla",
  players: "",
  valorTicket: "",
};

export const INIT_REGISTRO_FORM = {
  plataforma: "",
  torneioId: "",
  inscricoes: "1",
  premiacao: "",
  tickets: "",
  isSatellite: false,
};

export const INIT_FILTERS = {
  buyin: "",
  plataforma: "",
  modalidade: "",
  dataInicio: "",
  dataFim: "",
};

// ─── Seed Data ────────────────────────────────────────────────────────────────
export const SEED_TOURNAMENTS = [
  {
    id: 1,
    nome: "Sunday Main Event",
    buyin: "500",
    plataforma: "PokerStars",
    modalidade: "PKO",
    players: "312",
    valorTicket: "",
    criadoEm: new Date(Date.now() - 86400000 * 5).toISOString(),
  },
  {
    id: 2,
    nome: "High Roller Turbo",
    buyin: "2000",
    plataforma: "GG Poker",
    modalidade: "Hyper/Turbo",
    players: "85",
    valorTicket: "",
    criadoEm: new Date(Date.now() - 86400000 * 3).toISOString(),
  },
  {
    id: 3,
    nome: "Freezeout Daily",
    buyin: "150",
    plataforma: "ACR",
    modalidade: "Freezeout",
    players: "",
    valorTicket: "",
    criadoEm: new Date(Date.now() - 86400000 * 1).toISOString(),
  },
];

export const SEED_REGISTROS = [
  {
    id: 1,
    plataforma: "PokerStars",
    torneioId: 1,
    inscricoes: "2",
    premiacao: "8500",
    tickets: "",
    isSatellite: false,
    registradoEm: new Date(Date.now() - 86400000 * 2).toISOString(),
  },
  {
    id: 2,
    plataforma: "GG Poker",
    torneioId: 2,
    inscricoes: "1",
    premiacao: "0",
    tickets: "",
    isSatellite: false,
    registradoEm: new Date(Date.now() - 86400000 * 1).toISOString(),
  },
];
